import { Component, Inject, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { from, take } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';
import { PlatformService } from 'src/app/services/platform.service';
import { Browser } from '@capacitor/browser';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  constructor(
    private readonly navCtrl: NavController,
    public readonly platformService: PlatformService,
    @Inject(APP_CONFIG) public readonly appConfig: AppConfig,
    public readonly languageService: LanguageService
  ) {}

  ngOnInit() {
    return;
  }

  onBackButtonClick(): void {
    from(this.navCtrl.pop()) // pop() already makes back navigation
      .pipe(take(1))
      .subscribe((hasHistory) => {
        if (!hasHistory) {
          this.navCtrl.navigateRoot('/profile');
        }
      });
  }

  onTermsOfUseClick(): void {
    this.navCtrl.navigateForward('terms-of-use');
  }

  onImprintClick(): void {
    this.navCtrl.navigateForward('imprint');
  }
}
